import { Component } from '@angular/core';
import { TimerDirective } from '../../../core/timer/timer.directive';

@Component({
  selector: 'app-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.scss']
})
export class ControlsComponent {
  constructor(public d: TimerDirective) {}
}
